import { ArrowRight, Download } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden bg-[#050505]"
    >
      {/* Subtle stage texture far behind */}
      <div className="absolute inset-0 z-0">
        <img
          src="/images/gary-back-of-room.jpg"
          alt="Gary Zelesky on stage speaking to a live audience"
          className="w-full h-full object-cover opacity-10"
        />
        <div className="absolute inset-0 bg-[#050505]/60" />
      </div>

      {/* MAIN HERO PHOTO — dominant right side */}
      <div className="absolute top-0 right-0 bottom-0 z-10 w-full md:w-[55%] lg:w-[58%]">
        <div className="relative w-full h-full">
          <img
            src="/images/gary-blue-patterned.jpg"
            alt="Gary Zelesky, keynote speaker portrait"
            className="w-full h-full object-cover object-[center_30%]"
          />
          {/* Left fade into black so text remains readable */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/70 to-transparent md:from-[#050505] md:via-[#050505]/40 md:to-transparent" />
          {/* Right edge fade to blend cleanly */}
          <div className="absolute inset-0" style={{background: 'linear-gradient(to left, #050505 0%, rgba(5,5,5,0.95) 4%, rgba(5,5,5,0.5) 10%, transparent 22%)'}} />
          {/* Bottom fade for credibility row */}
          <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
        </div>
      </div>

      {/* Eyebrow pink stripe top */}
      <div className="absolute top-20 left-0 right-0 z-20 h-1 bg-[#EC1985]" />

      {/* Text content — left side */}
      <div className="relative z-20 max-w-7xl mx-auto px-6 md:px-10 pt-32 md:pt-36 pb-32 min-h-screen flex flex-col justify-center">
        <div className="max-w-2xl lg:max-w-3xl">
          <div className="flex items-center gap-3 mb-6 reveal">
            <span className="h-[2px] w-12 bg-[#EC1985]" />
            <span className="eyebrow">Keynote Speaker · Author · Human Defibrillator</span>
          </div>

          <h1
            data-testid="hero-heading"
            className="h-display text-[13vw] md:text-[8vw] lg:text-[7.5rem] xl:text-[9rem] text-white reveal"
            style={{ animationDelay: "0.1s" }}
          >
            <span className="block">Reignite</span>
            <span className="block">
              the <span className="text-[#EC1985]">Passion.</span>
            </span>
            <span className="block">Move People</span>
            <span className="block text-white/70">to Action.</span>
          </h1>

          <div
            className="mt-8 max-w-xl reveal"
            style={{ animationDelay: "0.25s" }}
          >
            <p className="text-base md:text-lg text-white/85 leading-relaxed font-medium">
              A 30-year keynote speaker who has impacted{" "}
              <span className="text-white font-extrabold">1,000,000+ people live</span> with
              humor, heart, and unforgettable takeaways.
            </p>
          </div>

          <div
            className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4 reveal"
            style={{ animationDelay: "0.4s" }}
          >
            <a href="#book" data-testid="hero-cta-book" className="btn-primary">
              Book Gary to Speak <ArrowRight size={18} />
            </a>
            <a href="#free-chapter" data-testid="hero-cta-watch" className="btn-ghost">
              <Download size={18} /> Free Chapter
            </a>
          </div>
        </div>
      </div>

      {/* Bottom credibility row */}
      <div className="absolute bottom-6 left-6 right-6 md:left-10 md:right-10 flex flex-wrap items-center justify-between gap-4 border-t border-white/15 pt-5 z-30 backdrop-blur-sm">
        <div className="text-[10px] md:text-xs uppercase tracking-[0.25em] text-white/60 font-bold">
          Trusted by MasterCard · Boeing · Hilton · Hinman · CareCredit · CDA · AAO
        </div>
        <div className="text-[10px] md:text-xs uppercase tracking-[0.25em] text-white/50">
          Scroll ↓
        </div>
      </div>
    </section>
  );
}
